export { default as BodegasTabs } from "./BodegasTabs";